import { render, staticRenderFns } from "./TiposDatos.view.vue?vue&type=template&id=f8f4a42e"
import script from "./TiposDatos.view.vue?vue&type=script&lang=js"
export * from "./TiposDatos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports